import { ProjectTypeBase } from './base/project-type-base';

export class ProjectType extends ProjectTypeBase { }